import React from "react";

const CheckBox = ({
  value,
  CheckBoxText,
  name,
  checked,
  onChange,
  dataId,
  className,
  labelClassName,
  labelText,
  onClick,
  divclassname

}) => {
  return (
    <>
      <input
        type="checkbox"
        className={className}
        value={value}
        id={dataId}
        name={name}
        checked={checked}
        onChange={onChange}
        onClick={onClick}
        divclassname={divclassname}
      />
      { labelText}
      <div className = {divclassname}>
      <label className={labelClassName} htmlFor={dataId} dangerouslySetInnerHTML={{ __html: CheckBoxText }}>
      </label>
      </div>
    </>
  );
};
export default CheckBox;
